import { IRouterLocationData } from "common/records/RouterLocation";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const LOCATION_CHANGE = "@routers/LOCATION_CHANGE";

export const RouterActions = {
  locationChange: (action: string, location: Partial<IRouterLocationData>) =>
    createAction(LOCATION_CHANGE, { location, action }),
};

export type RouterActions = ActionsUnion<typeof RouterActions>;
